import { gte } from 'semver';

export const isVersionGte = (version: string, targetVersion: string) => {
    try {
        return gte(version, targetVersion);
    } catch (err) {
        console.error('error while attempting to get version tag', err);
    }
};
